<template>
  <div class="h-full bg-documentGray">
    <FilePopup v-if="isFilePriview" v-bind:filedata="filePriviewData" @closePopup="closePopup"></FilePopup>
    <main class="main-wrapper flex-grow-1 bg-documentGray pdb-26">
      <div v-if="showThisSearch">
        <div class="d-flex align-items-center bg-white fix-header-title">
          <div
              class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
            {{ boardName }}
          </div>
          <div class="right-button mgr-24">
            <button class="mdc-icon-button" tabindex="0" @click="searchOpen" @keypress="searchOpen">
              <i class="material-icons  t-color-iconActive ">search</i></button>
          </div>
        </div>
        <div class="divider"></div>
      </div>

      <div v-if="!showThisSearch" class="searchbar d-flex align-items-center bg-white fix-header-title">
        <div class="d-flex align-items-center pdt-8 pdb-8 flex-grow-1">
          <div class="d-flex flex-grow-1 pdl-12">
            <i class="material-icons search_form_close mdc-icon-button  js--dropdown-toggle"
               tabindex="0" @click="searchClose();" @keypress="searchClose();">close</i>
            <input v-model="contents"
                   :placeholder="$t('1452')"
                   class="search_form w-full pdl-8 t-color-headlineBlack border-none t-headline8 font-r flex-grow-1 max-width-90p"
                   @keydown.enter="search"
                   type="text"/>
          </div>
          <div class="right-button mgr-24">
            <i class="material-icons mdc-icon-button  js--dropdown-toggle" tabindex="0" @click="search()" @keypress="search()">search</i>
          </div>
        </div>
      </div>

      <div v-if="!showThisSearch" class="divider"></div>
      <div class="shadow2 bg-white fix-header-title-content">
        <div v-if="mamberData" class="container container--narrow pdt-18 pdb-18 user_fixed">
          <div class="d-flex w-full justify-content-between">
            <div class="d-flex align-items-center flex-grow-1">
              <UserImgProfile :data="mamberData" :size="'s'" :className="'mgr-0'" />
              <div class="t-subtitle6 mgb-1 font-r mgl-16 ">
                <router-link :to="{name: 'MyPost',query:{board:boardId,boardName:boardName}}"
                             class="write_btn me t-color-headlineBlack font-r"
                             tabindex="0">
                  {{ mamberData.name ? $t('3437', {first: mamberData.name.first, last: mamberData.name.last}) : '' }}
                </router-link>
              </div>
            </div>
            <div class="d-flex ">
              <router-link v-if="selectedChild && selectedChild.register === true"
                           :to="{name: 'MyPost',query:{board:boardId,boardName:boardName}}"
                           class="mdc-button  d-flex flex-column pdt-32 myPostBtn mgr-8 h-auto"
                           tabindex="0">
                <div class="mdc-button__ripple custom-ripple"></div>
                <span class="mdc-button__label t-body3 t-color-iconInactive font-r rtl-support"> {{ $t('1428') }}</span>
              </router-link>
              <button v-if="selectedChild && selectedChild.register === true"
                      class="mdc-button  d-flex flex-column pdt-32 writePostBtn h-auto mgr--4"
                      tabindex="0" @click="changeRoute" @keypress="changeRoute">
                <div class="mdc-button__ripple custom-ripple"></div>
                <span class="mdc-button__label t-body3 t-color-iconInactive font-r">{{ $t('1429') }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="divider"></div>
      </div>
      <div v-if="listData.length > 0" class="container container--narrow pdt-30 1245">
<!--        <div class="t-body1 t-color-bodyGrayA mgb-16 font-r" v-if="contents !== ''">-->
<!--          {{ contents }}-->
<!--        </div>-->

        <!-- 상단 고정 게시물 -->
        <SocialLearningComponent :boardListData="fixedDataList"></SocialLearningComponent>
        <!-- 일반 게시물 -->
        <SocialLearningComponent :boardListData="listData"></SocialLearningComponent>

      </div>
      <div v-if="nosearch" class="container container--narrow pdt-50">
        <div class="t-headline8 t-center font-r ddd">{{ $t('1453') }}</div>
        <div class="t-body1 font-r t-color-bodyGrayA t-center mgt-4">{{ $t('1454') }}</div>
      </div>
      <div :class="!isNoData ? 'pdt-30':''" class="container container--narrow myClassDk 123">
        <SocialLearningNoData v-if="isNoData" :contents="contents"></SocialLearningNoData>
        <template v-if="listData.length > 0 && !listData[0].error ">
        </template>
        <infinite-loading v-if="boardId" ref="infiniteLoading" :identifier="infiniteId" spinner="spiral"
                          @infinite="fetchData">
          <div slot="no-more" class="mgt-16"></div>
          <div slot="no-results" class="mgt-16"></div>
        </infinite-loading>
      </div>
    </main>
  </div>
</template>
<script>
/**
 * 나의 학습 목록 메인 컴포넌트(social learning list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTopAppBar} from "@material/top-app-bar";
import {MDCRipple} from "@material/ripple";

import socialApi from "@/api/socialApi.js";
import SocialLearningNoData from "./SocialLearningNoData.vue";
import SocialLearningComponent from "@/components/common/SocialLearningComponent";
import InfiniteLoading from "vue-infinite-loading";

import {topAppBarMixin} from "../../mixins/topAppBar.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import FilePopup from "./FilePopup";
import {mapActions, mapState} from 'vuex'
import snackMessage from "@/plugins/snackMessage";

export default {
  components: {
    SocialLearningNoData,
    SocialLearningComponent,
    InfiniteLoading,
    TopAppBarDrawer,
    FilePopup,
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
  },
  data: function () {
    return {
      nosearch: false,
      isDrawerOpen: false,
      mamberData: [],
      contents: "",
      status: "",
      isNoData: false,
      campaignData: null,
      listData: [],
      fixedDataList: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      filePriviewData: [],
      isFilePriview: false,
      selectedChild: null,
      boardId: null,
      boardName: '',
      boardData: null,
      showThisSearch: true,
      firstCharOfNames: localStorage.getItem('firstChar'),
      bgColorOfName: localStorage.getItem('bgColors'),
    };
  },
  mixins: [topAppBarMixin],
  computed: {
    selectedTabBar() {
      return this.$route.meta.TabType;
    },
    ...mapState({
      likeCount: state => state.social.likeCount,
      viewCount: state => state.social.viewCount
    }),
  },
  watch: {
    likeCount(newLikeCount, oldLikeCount) {
      this.listData = this.listData.map((arr) => {
        if (newLikeCount.id == arr.id) {
          arr.likesCount = newLikeCount.likesCount;
          arr.like = newLikeCount.like;
        }
        return arr;
      });
    },
    viewCount(newViewCount, oldViewCount) {
      this.listData = this.listData.map((arr) => {
        if (newViewCount.id == arr.id) {
          arr.viewCount = newViewCount.viewCount;
          arr.commentCount = newViewCount.commentCount;
        }
        return arr;
      });
    },
    $route(to, from) {
      this.boardId = this.$route.params.board
      this.boardName = this.$route.query.boardName
      if (this.boardName) {
        this.boardName = this.boardName
      } else if (this.$route.hash) {
        this.boardName = this.$route.hash
      } else {
        this.boardName = this.$t("1427")
      }
      this.userAuth();
      this.closeDrawer();
      if (from.name !== 'SocialLearningView') {
        this.initData();
      }
    }
  },
  beforeMount() {
    this.boardId = this.$route.params.board
    this.boardName = this.$route.query.boardName
    if (this.boardName) {
      this.setTopAppBarHomeSearch(this.boardName);
    } else if (this.$route.hash) {
      this.boardName = decodeURIComponent(this.$route.hash)
    } else {
      this.setTopAppBarHomeSearch(this.$t("1427"));
    }
  },
  mounted() {
    this.userAuth();
    this.setMaterialUi();
    this.topAppBar = MDCTopAppBar.attachTo(
        document.querySelector(".mdc-top-app-bar")
    );
  },
  methods: {
    firstCharOfMemberName(name) {
      if(name.first) {
        let fullName = this.$t('3437', {first: name.first, last: name.last});
        return fullName.charAt(0);
      } else {
        let fullName = name.fullName;
        return fullName.charAt(1);
      }
    },
    changeRoute() {
      if (this.boardData.userBbsToDayAuth) {
        this.$router.push('/social-learning/write?board=' + this.boardId + "&boardName=" + this.boardName);
      } else {
        snackMessage(this.$t('3064'));
      }
    },
    priviewFiel(file) {
      this.filePriviewData = file;
      this.isFilePriview = true;
    },
    closePopup() {
      this.filePriviewData = Array();
      this.isFilePriview = false;
    },
    // method to redirect the user on Detail page if exists
    moveToDetail(record) {
      if (record && record.id) {
        this.$router.push('/socialLearning/' + this.boardId + '/' + record.id + '?boardName=' + encodeURI(this.boardName))
      }
    },
    userAuth() {
      socialApi
          .boardAuth(this.boardId)
          .then(response => {
            this.boardData = response.data.data;
            socialApi
                .fetchMember()
                .then(response => {
                  this.mamberData = response.data.data;
                  let myId = this.mamberData.responsibilityId
                  if (this.boardData.authType.value === 'STORE') {
                    this.selectedChild = this.boardData.authPermission[0];
                  } else {
                    this.selectedChild = this.boardData.authPermission.find(child => child.partId == myId);
                  }

                })
                .catch(err => {
                  $state.error();
                });
          })
          .catch(err => {
            $state.error();
          });
    },
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    fetchData($state) {
      let responseData = null;
      let params = this.setParams();

      if (this.totalPages >= this.currentPage) {
        socialApi
            .fetchList(params, this.boardId)
            .then(response => {
              responseData = response.data.data;
              _.map(responseData.content, o => {
                o.progressViewStatus = false;
              });

              this.fixedDataList = _.filter(responseData.content, {'fixed': true})
              this.listData = this.listData.concat(_.filter(responseData.content, {'fixed': false}))
              this.currentPage++;
              this.totalPages = responseData.totalPages;

              if (responseData.content.length) {
                $state.loaded();
              } else {
                $state.complete();
              }

              if (responseData.content.length > 0) {
                this.isNoData = false;
              } else {
                this.isNoData = true;
              }
            })
            .catch(err => {
              $state.error();
            });
      } else {
        $state.complete();
      }
    },
    // 파라미터 설정(set parameter)
    setParams() {
      let params = {
        sort: "id,desc",
        contents: this.contents,
        page: this.currentPage
      };
      return params;
    },
    // Open drawer
    openDrawer() {
      this.isDrawerOpen = true;
    },
    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },
    searchOpen() {
      $(".search_box").show();
      //	$(".sm_star").addClass("backBg");
      this.showThisSearch = false;
    },
    searchClose() {
      this.contents = '';
      this.showThisSearch = true;
      this.initData()
      this.isNoData = false;
      //this.$router.go(this.$router.currentRoute)
      $('.user_fixed').show();
      $(".search_box").hide();
      //	$(".sm_star").removeClass("backBg");
      //	$(".sm_list.learning").css("padding-top", "90px");
    },

    search() {
      this.initData();
      $('.user_fixed').hide();
    },

    patchLikeState(id, status, record) {
      this.$showLoading();
      let action = status
          ? socialApi.patchPostLike(this.boardId, id)
          : socialApi.patchPostDislike(this.boardId, id);

      action
          .then(response => {
            this.$hideLoading();
            record.likesCount = response.data.data.likesCount;
            //this.detail.like = !status;
          })
          .catch(err => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },
    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function (el) {
        let button = new MDCRipple.attachTo(el)
        return button
      })
    },
  },

};
</script>
<style scoped>
video-js {
  width: 100% !important;
  height: 100% !important;
}

.video-js video {
  width: 100% !important;
}

.max-width-90p {
  max-width: 90%;
}
</style>
